export default "__VITE_ASSET__4d19a76a__"